import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useParticipantAlerts } from "../../../../hooks/useParticipantAlerts";
import RequiresAttentionQuickViewPanel from "./RequiresAttentionQuickViewPanel";
import { sortAlertsByPriority } from "../../../../utils/alert-priority";

/**
 * Product (Maria, KAN-2384) asked for ALL of a patient's open alerts in the card — no
 * top-N cap and no "+N more" — so this requests one large page rather than paginating;
 * 100 is far above any realistic open-alert count for a single participant.
 */
export const REQUIRES_ATTENTION_CARD_PAGE_SIZE = 100;

const RequiresAttentionQuickView = ({ participantId }: { participantId: number }) => {
	const navigate = useNavigate();
	const { alerts, isLoading, error } = useParticipantAlerts(participantId, {
		rows: REQUIRES_ATTENTION_CARD_PAGE_SIZE,
		page: 0,
		first: 0,
	});

	/**
	 * The tab is newest-first (sorted server-side), but the card displays
	 * priority-first then newest (Maria's answer #2). The ordering is applied at
	 * the consumer, NOT by forking the hook, so both surfaces always agree on
	 * WHICH alerts exist.
	 */
	const sortedAlerts = useMemo(() => sortAlertsByPriority(alerts), [alerts]);

	return (
		<RequiresAttentionQuickViewPanel
			isLoading={isLoading}
			isError={!!error}
			alerts={sortedAlerts}
			onClickAction={() =>
				navigate(`/participant/${participantId}/requires-attention`, {
					replace: true,
				})
			}
		/>
	);
};
export default RequiresAttentionQuickView;
